import {
  QAlert,
  QAlertProps,
  QBox,
  QModal,
  QModalActions,
  QModalBody,
  QModalHeader,
  QSpinner,
  QStack,
  QText,
} from '@qualio/ui-components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export type BaseDocumentConvertModalProps = {
  warningText: QAlertProps['title'];
  messageList: string[];
  modalActionsFragment: JSX.Element[];
  onClose: (success: boolean) => void;
  messageListPrompt?: string;
  extendedModalBodyFragment?: ReactNode;
  isLoading?: boolean;
};

export const BaseDocumentConvertModal: React.FC<
  BaseDocumentConvertModalProps
> = ({
  onClose,
  warningText,
  messageListPrompt = 'Before changing the format, be sure to remember:',
  messageList,
  modalActionsFragment,
  extendedModalBodyFragment,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <QModal onClose={() => onClose(false)} isOpen={true} size="xl">
      <QModalHeader>
        <QText>{t('buttons.changeFormat')}</QText>
      </QModalHeader>
      <QModalBody>
        {isLoading ? (
          <QStack direction="column" align="center">
            <QSpinner data-cy="loading-convert-modal-body" />
          </QStack>
        ) : (
          <QStack spacing="6">
            <QAlert
              ml="-8px"
              mr="-8px"
              title={warningText}
              description={t('messages.thisChangeCanBeUndone')}
              status="warning"
            />
            <QBox>
              <QText>{t('convertFormat.beforeChangingFormatRemember')}</QText>
              <QBox pt="4" pl="6">
                <ul>
                  {messageList.map((message) => (
                    <li key={message}>
                      <QText>{message}</QText>
                    </li>
                  ))}
                </ul>
              </QBox>
            </QBox>
            {extendedModalBodyFragment}
          </QStack>
        )}
      </QModalBody>
      <QModalActions>{modalActionsFragment}</QModalActions>
    </QModal>
  );
};
